/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Other_KeysInputs */

const en_ai_other_keys = /** @type {(inputs: Ai_Other_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other services`)
};

const de_ai_other_keys = /** @type {(inputs: Ai_Other_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Dienste`)
};

/**
* | output |
* | --- |
* | "Other services" |
*
* @param {Ai_Other_KeysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_other_keys = /** @type {((inputs?: Ai_Other_KeysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Other_KeysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_other_keys(inputs)
	return en_ai_other_keys(inputs)
});